/** @format */
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconMoneyGiftcard,
	homefieldIconSignCircledCheckOutline
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';

@Component({
	selector: 'product-reviews-review-badges',
	templateUrl: './review-badges.component.html',
	styleUrl: './review-badges.component.scss',
	imports: [HomefieldIconLibraryModule, CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewBadgesComponent {
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	readonly badgeType = input('');

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconMoneyGiftcard,
			homefieldIconSignCircledCheckOutline
		]);
	}
}
